var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 367.05 368.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:url(#radial-gradient);}.cls-3{fill:#808285;}.cls-4{clip-path:url(#clip-path);}.cls-5{fill:#84dade;}.cls-6{fill:#aa004f;}.cls-7{fill:#fcd3ca;}.cls-8{fill:#c29fd8;}.cls-9{fill:#d1d3d4;}.cls-10{fill:#939598;}.cls-11{fill:#bcbec0;}.cls-12{fill:#a7a9ac;}.cls-13{fill:#a1dadf;}.cls-14{fill:#dcddde;}.cls-15{fill:#e6e7e8;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 186.68,
    cy: 184.19,
    r: 141,
    gradientTransform: "translate(184.64 -75.6) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#fefdfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#f9f6f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#f2ebf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#e7dae6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#d8c4d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#c7a8c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#b188b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#996297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#7e397c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#783076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 183.58,
    cy: 185.08,
    r: 140.65,
    transform: "translate(-77.11 184.02) rotate(-45)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 183.58,
    cy: 185.08,
    r: 140.65,
    transform: "translate(-77.11 184.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M22.3,131.24,5,135.24l2.11-6L18.45,127l-7.37-9,2.05-5.83L24,126.08l9.29,3.27-1.8,5.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26.6,112.27l-.06,0a12.78,12.78,0,0,1-4.71-17.74c3.73-6.66,11.37-8.65,17.5-5.21l.06,0a12.78,12.78,0,0,1,4.71,17.74C40.37,113.71,32.73,115.7,26.6,112.27Zm10.07-18-.06,0A7.51,7.51,0,0,0,26.17,97a7.4,7.4,0,0,0,3.09,10.24l.06,0a7.51,7.51,0,0,0,10.44-2.73A7.4,7.4,0,0,0,36.67,94.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46,83.27l-10.8-9.11L38.69,70l10.7,9c3.08,2.6,6,2.4,8.11-.14s1.89-5.38-1.1-7.9L45.57,61.85l3.5-4.16,10.67,9c5.73,4.83,5.83,10.41,1.55,15.49S51.55,88,46,83.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M57.61,49.32l8.68-7.24c2.41-2,4.85-2.9,7.14-2.69a7.72,7.72,0,0,1,5.24,3l0,.05a7.67,7.67,0,0,1,.84,9.28l10.3,2.91L85,58.68,75.84,56l0,0-3.23,2.69,5.07,6.07L73.45,68.3Zm16.1,2.2c2-1.69,2.3-3.75,1-5.35l0-.06c-1.5-1.79-3.51-1.67-5.55,0L64.93,49.6l4.55,5.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M88,41,88,41a12.56,12.56,0,0,1,4.8-17.51,12.78,12.78,0,0,1,10.35-1.55l-1,5.18a9.17,9.17,0,0,0-6.87.74c-3.62,2.08-4.49,6.57-2.38,10.25l0,.06C95,41.79,99.31,43.39,103,41.28c2.45-1.41,3.39-3.25,4.19-5.75l4.75,1.3a12.65,12.65,0,0,1-6.59,8.88A12.47,12.47,0,0,1,88,41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M119.47,11.35l4.73-1.67,18.29,19.94-5.36,1.89-4-4.47-9.86,3.49-.28,6-5.22,1.85Zm10.25,11.81L124,16.7l-.43,8.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M144.38,4l11.16-1.79c3.1-.5,5.65,0,7.51,1.33a7.75,7.75,0,0,1,3,5.24v.07a7.69,7.69,0,0,1-4,8.41l7.36,7.76-6.27,1-6.49-7h-.07l-4.14.66,1.25,7.81-5.37.87Zm12.71,10.12c2.62-.42,3.89-2.06,3.56-4.11V10c-.37-2.3-2.16-3.23-4.78-2.81L150.53,8l1.12,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M176.11,0l18.64.31-.08,4.83-13.24-.21-.08,5,11.65.19L192.92,15l-11.65-.19L181.18,20l13.42.22L194.52,25l-18.82-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M202.55,13.18v-.07a12.69,12.69,0,0,1,15-10.29,13.6,13.6,0,0,1,9,5.06l-4.11,3.46a9.07,9.07,0,0,0-5.91-3.61c-3.9-.7-7.61,2.18-8.35,6.32l0,.07c-.8,4.45,1.67,8.26,6,9a8.7,8.7,0,0,0,5.31-.55l.62-3.48-5.38-1,.83-4.62,10.56,1.9L224.17,26a16.05,16.05,0,0,1-11.09,2C205.51,26.63,201.25,20.37,202.55,13.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M238.45,8.4l5.17,1.69-7.68,23.5-5.17-1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M252.7,13l5.41,2.61-1.74,18.49,13.39-12.87L275,23.81,255.21,41.9l-4.32-2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M283.58,29.23,298.76,40,296,44,285.17,36.3l-2.91,4.09,9.49,6.76-2.81,3.94-9.49-6.76-3,4.22,10.93,7.79-2.81,3.94L269.23,49.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M307.31,47.27l8,8c2.22,2.22,3.32,4.56,3.33,6.86a7.77,7.77,0,0,1-2.5,5.5l-.05,0a7.67,7.67,0,0,1-9.16,1.68l-2,10.51-4.5-4.49L302.31,66l-.05,0-3-3-5.58,5.6-3.85-3.84Zm-.73,16.24c1.87,1.87,3.94,1.94,5.42.47l.05,0c1.64-1.65,1.34-3.65-.53-5.52l-3.83-3.82-5,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M312.71,80.92l3.52,4.51-4.46,3.48-3.52-4.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M325.41,86.23l.06,0a12.57,12.57,0,0,1,17.62,4.39,12.77,12.77,0,0,1,1.79,10.32l-5.21-.89a9.16,9.16,0,0,0-.89-6.86c-2.16-3.56-6.67-4.33-10.3-2.13l-.06,0c-3.62,2.2-5.12,6.54-2.92,10.16,1.46,2.42,3.32,3.31,5.84,4.06l-1.2,4.77a12.63,12.63,0,0,1-9-6.38A12.47,12.47,0,0,1,325.41,86.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M355.79,117l1.79,4.69-19.52,18.74-2-5.31,4.38-4.09-3.71-9.77-6-.14-2-5.19Zm-11.57,10.51,6.33-5.92-8.66-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.6,217.68l1.68,5.76L14.37,234.51l18.52,1.34,1.64,5.63L7.84,238.84l-1.35-4.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25.11,251.44l.07,0a12.77,12.77,0,0,1,17.38,5.89c3.49,6.79.92,14.26-5.33,17.46l-.07,0a12.8,12.8,0,0,1-17.39-5.9A12.67,12.67,0,0,1,25.11,251.44Zm9.4,18.33.06,0a7.52,7.52,0,0,0,3.5-10.21,7.39,7.39,0,0,0-10.24-3.09l-.06,0a7.51,7.51,0,0,0-3.5,10.21A7.4,7.4,0,0,0,34.51,269.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M51.78,282.46l-4.57-6,4-3.05L63.65,289.7l-4,3.05-4.58-6-15.64,12-3.31-4.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M68.54,295l8.29,7.68c2.31,2.13,3.5,4.43,3.59,6.73A7.75,7.75,0,0,1,78.14,315l0,.05a7.67,7.67,0,0,1-9.09,2l-1.57,10.58-4.66-4.32,1.48-9.4,0-.05L61.11,311l-5.37,5.81-4-3.69Zm-.12,16.25c1.94,1.8,4,1.79,5.43.26l.05,0c1.58-1.71,1.21-3.69-.74-5.49l-4-3.67-4.82,5.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M90.12,313.8l15.67,10.11L103.16,328,92,320.8,89.32,325l9.79,6.32-2.62,4.07-9.8-6.32-2.81,4.36,11.28,7.28-2.63,4.07L76.71,334.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M104.54,347.08l4.45-2.3a11.33,11.33,0,0,0,5.64,5.63c2.05.86,3.63.57,4.19-.76l0-.07c.53-1.27,0-2.25-3.37-4.83-4.1-3.1-6.53-5.62-4.62-10.14l0-.07c1.74-4.13,6.21-5.47,10.86-3.51a14.31,14.31,0,0,1,7.24,6.46l-4.19,2.68a11.62,11.62,0,0,0-5-4.74c-1.92-.81-3.3-.35-3.76.75l0,.07c-.63,1.5.14,2.39,3.65,5.06,4.12,3.15,6,5.91,4.35,9.88l0,.06c-1.91,4.53-6.43,5.61-11.34,3.55A15.75,15.75,0,0,1,104.54,347.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M134.8,349.8v-.06A12.79,12.79,0,0,1,150.37,340c7.47,1.6,11.63,8.31,10.16,15.18v.07A12.79,12.79,0,0,1,145,365C137.5,363.39,133.33,356.68,134.8,349.8Zm20.14,4.31V354a7.5,7.5,0,0,0-5.69-9.16,7.39,7.39,0,0,0-8.87,6v.07a7.51,7.51,0,0,0,5.7,9.17A7.39,7.39,0,0,0,154.94,354.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M170.83,343.42l5.42.34-1.53,24.67-5.43-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M184.73,356.74v-.07a12.69,12.69,0,0,1,12-13.73,13.56,13.56,0,0,1,9.94,2.65L203.52,350a9.08,9.08,0,0,0-6.63-2c-3.95.29-6.81,4-6.5,8.21v.07c.34,4.51,3.69,7.58,8.06,7.25a8.67,8.67,0,0,0,5-1.86l-.27-3.53-5.45.42-.36-4.69,10.71-.81.81,10.71a16.1,16.1,0,0,1-10.24,4.71C191,369,185.29,364,184.73,356.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M216,341l4.83-1.35,15.27,11.53-4.12-14.66,5.17-1.45,6.68,23.81-4.46,1.25L223.55,348.2l4.25,15.14-5.17,1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M253.44,327.57l4.47-2.28,20.76,17.35-5.06,2.59-4.54-3.91-9.3,4.76.51,6-4.94,2.53Zm11.72,10.36-6.57-5.65.72,8.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M273.53,316.45l3.93-3.11L296,318.08l-9.45-11.93,4.2-3.33,15.35,19.37-3.62,2.87-19.15-4.88,9.76,12.32-4.2,3.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M304.81,295.33l-5,5.65-3.77-3.31,13.53-15.38,3.77,3.32-5,5.64,14.79,13-3.59,4.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M326.93,290.48l3.32-4.66,4.6,3.27-3.32,4.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M330.81,273.31l-.06,0A12.58,12.58,0,0,1,325.28,256a12.78,12.78,0,0,1,7.86-6.92l2,4.9a9.14,9.14,0,0,0-5.37,4.35c-1.91,3.7-.21,8,3.56,9.9l.06,0c3.77,1.94,8.25.95,10.19-2.81,1.3-2.52,1.08-4.57.4-7.11l4.7-1.48a12.68,12.68,0,0,1-.72,11A12.48,12.48,0,0,1,330.81,273.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M335.24,231.87l1.4-4.81,26.87-3.21-1.59,5.46-6,.62L353,240l4.69,3.72L356.18,249Zm15.57-1.42-8.61.91,6.77,5.39Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lCzI6e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M172.58,334.66c-5.82-.28-17.69-4.16-28-4.91-13.2-.95-32.7-16.17-45.45-19.9-6-1.75-11.08-20.67-16.23-24.29-7.22-5.07,5.21-28.95,7.55-37.46a78.76,78.76,0,0,1,10-22.81c6.09-9.19,14.15-15.45,25.31-17.11a4,4,0,0,0,2.75-1.73,25.77,25.77,0,0,0,4.32-10.56,84.71,84.71,0,0,0,1.38-22.07c-.43-7.46-.95-14.93-2-22.32-1.94-14-.06-27.54,3.91-40.88A52,52,0,0,1,148.38,89a41.05,41.05,0,0,1,25.55-12.75,98.07,98.07,0,0,1,11.12-.3,97.75,97.75,0,0,1,11.49.3A41.14,41.14,0,0,1,223.84,91c6.67,7.86,10.3,17.16,12.55,27.08a119,119,0,0,1,2.69,26.48c0,2.56-.7,5.11-1,7.68-.6,5.52-1.36,11-1.62,16.57-.29,5.95-.27,11.94,0,17.9.23,5.81,1.13,11.54,3.71,16.87.08.15.16.29.23.44a7.39,7.39,0,0,0,5.89,4.51c10,1.65,17.29,7.51,22.94,15.61a69.72,69.72,0,0,1,11.11,25.67c1.71,8.14,18.51,48.95,11.6,53.79-5.4,3.78-26.07,9.51-32.34,11.3-8.72,2.49-27.64,32.68-36.63,33.79C208.77,350.44,191.37,334.49,172.58,334.66Zm49.58-172.59c1.16.59,2.23.08,3.14-.93a7.71,7.71,0,0,0,1-1.3A21.45,21.45,0,0,0,229,147a12.45,12.45,0,0,0-1.31-4c-.41-.86-1.2-1.1-2-.16-1.09,1.31-2.24,2.58-3.37,3.87a7.77,7.77,0,0,0-1.27-.77q-26.42-13.59-52.82-27.18a4.52,4.52,0,0,0-1.75-.58,15,15,0,0,0-10.9,3.57,24.38,24.38,0,0,0-7.2,11.67c-.94,3-1.56,6.08-2.32,9.1-1.81-.74-2.83-.32-3.62,1.61a3.49,3.49,0,0,0-.33,1.07,47.88,47.88,0,0,0-.22,6.21,17.66,17.66,0,0,0,3.14,9.12c1.24,1.72,2.1,2,3.91,1.5.9,2.24,1.72,4.51,2.7,6.71,4,8.83,9.26,16.73,17,22.7,5.1,3.91,10.76,6.35,17.33,6.19a26.65,26.65,0,0,0,14.76-5.19,49.48,49.48,0,0,0,15-17.1C218.13,171.08,220,166.57,222.16,162.07ZM150,205.37a7.89,7.89,0,0,0,2.72,5.15q16.05,15.93,32.18,31.77a2.12,2.12,0,0,0,.42.25c.35-.32.66-.59,1-.88,7.29-7,14.63-14.07,21.86-21.19,3.6-3.54,7-7.26,10.47-11a6.55,6.55,0,0,0,1.87-3.82c-2.22-1.63-4.34-2.95-6.19-4.59a9.56,9.56,0,0,1-2.91-6.76c-14.24,14.12-33.51,18-51.91.07C158.93,200.38,154.89,203.29,150,205.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M222.16,162.07c-2.14,4.5-4,9-6.38,13.25a49.48,49.48,0,0,1-15,17.1A26.65,26.65,0,0,1,186,197.61c-6.57.16-12.23-2.28-17.33-6.19-7.77-6-13-13.87-17-22.7-1-2.2-1.8-4.47-2.7-6.71-1.81.5-2.67.22-3.91-1.5a17.66,17.66,0,0,1-3.14-9.12,47.88,47.88,0,0,1,.22-6.21,3.49,3.49,0,0,1,.33-1.07c.79-1.93,1.81-2.35,3.62-1.61.76-3,1.38-6.11,2.32-9.1a24.38,24.38,0,0,1,7.2-11.67,15,15,0,0,1,10.9-3.57,4.52,4.52,0,0,1,1.75.58q26.42,13.58,52.82,27.18a7.77,7.77,0,0,1,1.27.77c1.13-1.29,2.28-2.56,3.37-3.87.78-.94,1.57-.7,2,.16a12.45,12.45,0,0,1,1.31,4,21.45,21.45,0,0,1-2.74,12.89,7.71,7.71,0,0,1-1,1.3C224.39,162.15,223.32,162.66,222.16,162.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M150,205.37c4.91-2.08,9-5,9.47-11,18.4,17.94,37.67,14.05,51.91-.07a9.56,9.56,0,0,0,2.91,6.76c1.85,1.64,4,3,6.19,4.59a6.55,6.55,0,0,1-1.87,3.82c-3.44,3.7-6.87,7.42-10.47,11-7.23,7.12-14.57,14.14-21.86,21.19-.3.29-.61.56-1,.88a2.12,2.12,0,0,1-.42-.25q-16.09-15.87-32.18-31.77A7.89,7.89,0,0,1,150,205.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M172.58,334.66c-5.82-.28-17.69-4.16-28-4.91-13.2-.95-32.7-16.17-45.45-19.9-6-1.75-11.08-20.67-16.23-24.29-7.22-5.07,5.21-28.95,7.55-37.46a78.76,78.76,0,0,1,10-22.81c6.09-9.19,14.15-15.45,25.31-17.11a4,4,0,0,0,2.75-1.73,25.77,25.77,0,0,0,4.32-10.56,84.71,84.71,0,0,0,1.38-22.07c-.43-7.46-.95-14.93-2-22.32-1.94-14-.06-27.54,3.91-40.88A52,52,0,0,1,148.38,89a41.05,41.05,0,0,1,25.55-12.75,98.07,98.07,0,0,1,11.12-.3,97.75,97.75,0,0,1,11.49.3A41.14,41.14,0,0,1,223.84,91c6.67,7.86,10.3,17.16,12.55,27.08a119,119,0,0,1,2.69,26.48c0,2.56-.7,5.11-1,7.68-.6,5.52-1.36,11-1.62,16.57-.29,5.95-.27,11.94,0,17.9.23,5.81,1.13,11.54,3.71,16.87.08.15.16.29.23.44a7.39,7.39,0,0,0,5.89,4.51c10,1.65,17.29,7.51,22.94,15.61a69.72,69.72,0,0,1,11.11,25.67c1.71,8.14,18.51,48.95,11.6,53.79-5.4,3.78-26.07,9.51-32.34,11.3-8.72,2.49-27.64,32.68-36.63,33.79C208.77,350.44,191.37,334.49,172.58,334.66Zm49.58-172.59c1.16.59,2.23.08,3.14-.93a7.71,7.71,0,0,0,1-1.3A21.45,21.45,0,0,0,229,147a12.45,12.45,0,0,0-1.31-4c-.41-.86-1.2-1.1-2-.16-1.09,1.31-2.24,2.58-3.37,3.87a7.77,7.77,0,0,0-1.27-.77q-26.42-13.59-52.82-27.18a4.52,4.52,0,0,0-1.75-.58,15,15,0,0,0-10.9,3.57,24.38,24.38,0,0,0-7.2,11.67c-.94,3-1.56,6.08-2.32,9.1-1.81-.74-2.83-.32-3.62,1.61a3.49,3.49,0,0,0-.33,1.07,47.88,47.88,0,0,0-.22,6.21,17.66,17.66,0,0,0,3.14,9.12c1.24,1.72,2.1,2,3.91,1.5.9,2.24,1.72,4.51,2.7,6.71,4,8.83,9.26,16.73,17,22.7,5.1,3.91,10.76,6.35,17.33,6.19a26.65,26.65,0,0,0,14.76-5.19,49.48,49.48,0,0,0,15-17.1C218.13,171.08,220,166.57,222.16,162.07ZM150,205.37a7.89,7.89,0,0,0,2.72,5.15q16.05,15.93,32.18,31.77a2.12,2.12,0,0,0,.42.25c.35-.32.66-.59,1-.88,7.29-7,14.63-14.07,21.86-21.19,3.6-3.54,7-7.26,10.47-11a6.55,6.55,0,0,0,1.87-3.82c-2.22-1.63-4.34-2.95-6.19-4.59a9.56,9.56,0,0,1-2.91-6.76c-14.24,14.12-33.51,18-51.91.07C158.93,200.38,154.89,203.29,150,205.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M222.16,162.07c-2.14,4.5-4,9-6.38,13.25a49.48,49.48,0,0,1-15,17.1A26.65,26.65,0,0,1,186,197.61c-6.57.16-12.23-2.28-17.33-6.19-7.77-6-13-13.87-17-22.7-1-2.2-1.8-4.47-2.7-6.71-1.81.5-2.67.22-3.91-1.5a17.66,17.66,0,0,1-3.14-9.12,47.88,47.88,0,0,1,.22-6.21,3.49,3.49,0,0,1,.33-1.07c.79-1.93,1.81-2.35,3.62-1.61.76-3,1.38-6.11,2.32-9.1a24.38,24.38,0,0,1,7.2-11.67,15,15,0,0,1,10.9-3.57,4.52,4.52,0,0,1,1.75.58q26.42,13.58,52.82,27.18a7.77,7.77,0,0,1,1.27.77c1.13-1.29,2.28-2.56,3.37-3.87.78-.94,1.57-.7,2,.16a12.45,12.45,0,0,1,1.31,4,21.45,21.45,0,0,1-2.74,12.89,7.71,7.71,0,0,1-1,1.3C224.39,162.15,223.32,162.66,222.16,162.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M150,205.37c4.91-2.08,9-5,9.47-11,18.4,17.94,37.67,14.05,51.91-.07a9.56,9.56,0,0,0,2.91,6.76c1.85,1.64,4,3,6.19,4.59a6.55,6.55,0,0,1-1.87,3.82c-3.44,3.7-6.87,7.42-10.47,11-7.23,7.12-14.57,14.14-21.86,21.19-.3.29-.61.56-1,.88a2.12,2.12,0,0,1-.42-.25q-16.09-15.87-32.18-31.77A7.89,7.89,0,0,1,150,205.37Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M230.48,297.59l23.1-24.23a16.13,16.13,0,0,0-22.37-23.21l-.75.65-.74-.65a16.12,16.12,0,0,0-22.37,23.21l23.1,24.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M248.5,255.59a9.7,9.7,0,0,0-12.63-.12l-5.51,4.83-5.5-4.83a9.71,9.71,0,0,0-12.64.12,9.15,9.15,0,0,0,0,12.87l18.11,18.88,18.12-18.88A9.15,9.15,0,0,0,248.5,255.59Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "19.31 176.82 19.31 176.82 21.46 169.66 21.38 169.58 13.92 169.58 13.82 169.72 19.31 176.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "13.71 195.45 13.74 195.56 13.82 195.68 27.55 176.82 19.31 176.82 13.71 195.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "27.55 176.82 27.65 176.69 21.46 169.66 19.31 176.82 27.55 176.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "13.82 169.72 9.13 176.82 19.31 176.82 13.82 169.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "19.31 176.82 9.13 176.82 8.96 177.08 9.13 176.82 8.9 176.82 13.71 195.45 19.31 176.82 19.31 176.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "13.92 169.58 13.72 169.58 13.82 169.72 13.92 169.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "8.9 176.82 0.1 176.82 13.7 195.5 13.71 195.45 8.9 176.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "7.04 169.64 0 176.69 0.1 176.82 8.9 176.82 7.04 169.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "9.13 176.82 13.82 169.72 13.72 169.58 7.11 169.58 7.04 169.64 8.9 176.82 9.13 176.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "358.75 176.82 358.75 176.82 360.89 169.66 360.82 169.58 353.39 169.58 353.3 169.72 358.75 176.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "353.19 195.45 353.22 195.56 353.3 195.68 366.96 176.82 358.75 176.82 353.19 195.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "366.96 176.82 367.05 176.69 360.89 169.66 358.75 176.82 366.96 176.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "353.3 169.72 348.63 176.82 358.75 176.82 353.3 169.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "358.75 176.82 348.63 176.82 348.46 177.08 348.63 176.82 348.4 176.82 353.19 195.45 358.75 176.82 358.75 176.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "353.39 169.58 353.19 169.58 353.3 169.72 353.39 169.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "348.4 176.82 339.64 176.82 353.17 195.5 353.19 195.45 348.4 176.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "346.55 169.64 339.55 176.69 339.64 176.82 348.4 176.82 346.55 169.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "348.63 176.82 353.3 169.72 353.19 169.58 346.62 169.58 346.55 169.64 348.4 176.82 348.63 176.82"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogo);
export default __webpack_public_path__ + "static/media/main-logo.9c86736988a0274cbc5cae2ba17ec442.svg";
export { ForwardRef as ReactComponent };